// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Furusato from '../_raw/service/icon_furusato.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Furusato);
